// extracted by mini-css-extract-plugin
export default {"wrapper":"Main_wrapper__DnfIf","mainBlock":"Main_mainBlock__Awk4b","img":"Main_img__iFR1+","absImg":"Main_absImg__Qkjhi","morph":"Main_morph__Oodrv","info":"Main_info__uNOz9"};